export const SELLER_PAGE_IMAGE_FIT_MODES = ['cover', 'top', 'contain'];

// event.design → account.design → 'cover'; unknown/absent values degrade to 'cover'
// so old data and a lagging BE deploy render exactly as today.
export const resolveSellerPageImageFit = (eventDesign, accountDesign) => {
  const eventValue = eventDesign?.sellerPageImageFit;
  if (SELLER_PAGE_IMAGE_FIT_MODES.includes(eventValue)) return eventValue;
  const accountValue = accountDesign?.sellerPageImageFit;
  if (SELLER_PAGE_IMAGE_FIT_MODES.includes(accountValue)) return accountValue;
  return 'cover';
};

export const imageFitToStyle = (mode) => {
  if (mode === 'top') return { objectFit: 'cover', objectPosition: 'top' };
  if (mode === 'contain') return { objectFit: 'contain' };
  return { objectFit: 'cover' };
};
